import _ from 'lodash';
import React, { useCallback }  from 'react';
import { Icon, PropTypes, formatName } from '~/utils';
import { PickList } from './PickList';

export function PersonList( props_in ) {
  const { people, iconPresent, iconAbsent, ...props } = props_in;
  const renderPerson = useCallback( ( person ) => {
    const icon = () => {
      switch ( person.present ) {
        case true: return <Icon icon={iconPresent} pull="right" />;
        case false: return <Icon icon={iconAbsent} pull="right" />;
        default: return null;
      }
    };
    return ( <span>{formatName( person )}{icon()}</span> );
  }, [ iconPresent, iconAbsent ] );
  return <PickList
    {...props}
    items={people}
    renderItem={renderPerson}
  />;
}
PersonList.propTypes = {
  people        : PropTypes.arrayOf( PropTypes.shape( {
    id          : PropTypes.string.isRequired,
  } ) ),
  iconPresent : PropTypes.string.isRequired,
  iconAbsent  : PropTypes.string.isRequired,
};
PersonList.defaultProps = {
  iconPresent : 'far:user-circle',
  iconAbsent  : 'far:circle',
};
